<template>
    <span :title="formatDate(datetime, 'LLL zz')" v-bind="$attrs">
        {{ formatDate(datetime, format) }}
    </span>
</template>

<script>
export default {
    name: 'DatetimeDisplay',

    props: {
        datetime: {
            type: [Object, String],
            required: true,
        },

        format: {
            type: String,
            required: true,
        },

        timezone: {
            type: String,
            required: false,
            default: 'America/Los_Angeles',
        },
    },

    methods: {
        formatDate(date, format = 'Y-MM-DD hh:mm:ss', fromNow = false) {
            const dateString = date instanceof this.$moment ? date.toDate() : date;

            const momentDate = this.$moment.utc(dateString).tz(this.timezone);

            return fromNow ? momentDate.fromNow() : momentDate.format(format);
        },
    },
};
</script>
